// Environment-specific configuration - Updated for Direct API
export const config = {
  // API Configuration - Direct Cloud Run custom domain
  API_BASE_URL: process.env.REACT_APP_API_BASE || 'https://api.happyfamilyai.com/api',
  
  WS_BASE_URL: process.env.REACT_APP_WS_BASE || 'https://happyfamilyai-api-yjimsdhbsa-ew.a.run.app/api',
  
  // App Configuration
  APP_NAME: 'HappyFamilyAI',
  VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  
  // Feature Flags
  ENABLE_DEBUG: process.env.REACT_APP_DEBUG === 'true',
  ENABLE_WEBSOCKET: process.env.REACT_APP_ENABLE_WEBSOCKET !== 'false',
  
  // Environment
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
};

export default config;
